import React, { useMemo } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { StyleProp, TextStyle } from 'react-native';

export type PeriodType = 'lastHour' | 'last12Hour' | 'last24Hours' | 'today' | 'weekly' | 'fortnightly' | 'monthly' | 'semiannual' | 'annual' | 'allPeriod' | 'select';

interface Props {
    value: PeriodType;
    setValue: React.Dispatch<React.SetStateAction<PeriodType>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    periods?: PeriodType[];
    label?: string;
}

function PeriodDropdown({ value, setValue, periods, zIndex, labelStyle, viewStyle, label }: Props) {
    const items = useMemo(() => {
        let options = [];

        if (periods) {
            options = periods;
        } else {
            options = [
                'today',
                'weekly',
                'fortnightly',
                'monthly',
                'semiannual',
                'allPeriod',
            ];
        }

        return options.map(situation => {
            return { label: translate(situation), value: situation };
        });

    }, []);

    return (
        <FilterDropdown
            label={label}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={[{ minWidth: 223 }, viewStyle]}
        />
    );
}

export default PeriodDropdown;
